import classNames from "classnames";

import { FilterChip } from "./FilterChip";
import { Facet } from "./FilteredGrid";

export const FilterChips = ({
  facets,
  onClick,
  className,
}: {
  facets: Facet[];
  // * NOTE: This is not an additive onClick.
  // * This rather overrides the baked in behavior of this component.
  // * See ProductFilterView for primary usage of this.
  onClick?: (facet: Facet) => void;
  className?: string;
}) => (
  <div className={classNames("flex md:flex-wrap gap-1", className)}>
    {facets.map((facet) => {
      return (
        facet && (
          <FilterChip facet={facet} key={facet.value} onClick={onClick} />
        )
      );
    })}
  </div>
);
